import React from 'react'
import { Link } from 'react-router-dom'

import moment from 'moment'

import '../chat/Chat.scss' // Reuse styles

/** Maps the notification type string (set by the backend handler) to a friendly CTA label. */
function getButtonLabel(type) {
  switch (type) {
    case 'ReportReady':
      return 'Go to Reports'
    case 'TaskAssignment':
      return 'Go to Task'
    case 'AppointmentCreated':
    case 'AppointmentAssigned':
      return 'Go to Appointment'
    default:
      return 'Go to Case'
  }
}

/**
 * Renders a notification body string, turning "Case #NNNNN" occurrences into
 * in-app links so the recipient can jump directly to the case without using
 * the main CTA button.
 */
function renderBodyWithLinks(body) {
  if (!body) return null
  const parts = body.split(/(Case #\d+)/g)
  return parts.map((part, i) => {
    const match = part.match(/^Case #(\d+)$/)
    if (match) {
      return (
        <Link key={i} to={`/cases/${match[1]}`} className="font-weight-bold">
          {part}
        </Link>
      )
    }
    return <span key={i}>{part}</span>
  })
}

const NotificationMessageTray = ({ isOpen, onClose, message }) => {
  if (!message) return null

  const buttonLabel = getButtonLabel(message.type)

  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */}
      <div className={`chat-drawer-overlay ${isOpen ? 'visible' : ''}`} onClick={onClose} />
      <div className={`chat-drawer ${isOpen ? 'open' : ''}`}>
        <div className="chat-drawer-header">
          <h5 className="mb-0">Message</h5>
          <button className="btn btn-sm btn-close" onClick={onClose}></button>
        </div>

        <div className="p-3">
          <div className="mb-3">
            <h6 className="font-weight-bold mb-1">{message.title}</h6>
            <div className="text-muted small mb-2">
              {moment.utc(message.createdUtc).local().format('MMMM Do YYYY, h:mm a')}
            </div>
            {message.senderName && (
              <div className="text-muted small mb-2">
                <strong>From:</strong> {message.senderName}
              </div>
            )}
          </div>

          <div className="bg-light p-3 rounded mb-4" style={{ whiteSpace: 'pre-wrap' }}>
            {renderBodyWithLinks(message.body)}
          </div>

          {message.deepLink && (
            <div className="text-center">
              <Link to={message.deepLink} className="btn btn-primary btn-block" onClick={onClose}>
                {buttonLabel}
              </Link>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default NotificationMessageTray
